import { cn } from '@mntn-dev/ui-utilities'
import { type PropsWithChildren, forwardRef } from 'react'
import { type TestIds, getTestProps } from '../../../utils/testing.ts'

export type MenuOptionsProps = PropsWithChildren<
  TestIds & { className?: string }
>

export const MenuOptions = forwardRef<HTMLDivElement, MenuOptionsProps>(
  ({ children, className, dataTestId, dataTrackingId }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'w-full flex flex-col divide-y divide-container rounded-sm border border-container text-sm shadow-lg bg-container-secondary backdrop-blur-xl',
          className
        )}
        {...getTestProps({ dataTestId, dataTrackingId })}
      >
        {children}
      </div>
    )
  }
)
